import api from "axios";

export default function getAdvertiser(url = '') {

  return api
  .get(`/company/${url}`)
  .then((response) => response.data.payload.data);
}